import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";

export const teacherStatistice = createAsyncThunk(
  "teacher/course/getAll",
  async () => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
  const request = await fetch(
    `${process.env.REACT_APP_VERSEL_API}/api/teacher/teacherStatistics/`,
    {
      method: "GET",
      headers:{
        "Authorization" : `Bearer ${tokenData}`
      }
    }
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      formatError(error);
    });

  return request;
});

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getTeacherStatistice = createSlice({
  name: "getCouses",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(teacherStatistice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(teacherStatistice.fulfilled, (state, action) => {
        state.loading = false;

      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      }
     else  if (action.payload.message === "fetched successfully") {
        state.data = action.payload;
     
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(teacherStatistice.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });

  },
});

export default getTeacherStatistice.reducer;

